import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
//import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import LockIcon from '@material-ui/icons/LockOutlined';
import {styles} from './style';
import { VisitorPost, token, GetData} from '../../store/request';
import Snackbar from '@material-ui/core/Snackbar';

class Step3 extends Component {
  constructor(props){
    super();
    this.onNextClick = this.onNextClick.bind(this);
    this.state = {
      password: props.Register.password,
      confirmPassword: props.Register.confirmPassword,
      errorPassword : false,
      errorCPassword : false,
      loading: false,
      errorMessage: '',
    }
  }
  onNextClick(){
    if(!this.state.password){
      this.setState({errorPassword: true});
    }
    else if(!this.state.confirmPassword || this.state.password!==this.state.confirmPassword){
      this.setState({errorCPassword: true});
    }
    else{
      this.setState({loading: true});
      const {Register} = this.props;
      let country = Register.countryList.find(m=> m.countryName===Register.country);
      //const country = Register.countryList.find(c => c.dialingCode===Register.country);
      console.log(country, Register.country, Register.countryList);
      const requestData = {
        FirstName: Register.firstName,
        LastName: Register.lastName,
        PhoneNumber: Register.number,
        Email: Register.email,
        Password: this.state.password,
        CountryName: country.countryName,
        CountryDialingCode: country.dialingCode,
        CreatedDate: new Date().toISBString()
      };
      VisitorPost('/RegisterUser', requestData, data=>{
        if(data.code==='001'){
          //let tenant = data.Result[0];
          token('/token', "grant_type=password&username="+Register.email+"&password="+this.state.password+"&authenticationmode=custom", token => {
            localStorage.setItem('_lg', true);
            localStorage.setItem('_access', token.access_token);
            GetData('/GetUserDetails').then(userData => {
              localStorage.setItem('_user', JSON.stringify(userData.result));
              this.props.history.push('/');
            });
          })
        }
        else{
          this.setState({loading: false, errorMessage: data.message});
        }
      })
    }
  }
  handleChange = prop => event => {
    let errorCheck={}
    if(prop==='password'){
      errorCheck={errorPassword: false}
    }
    else if(prop==='confirmPassword'){
      errorCheck={errorCPassword: false}
    }
    this.setState({ [prop]: event.target.value, ...errorCheck});
  };
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({ errorMessage: '' });
  };
  _handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      this.onNextClick();
    }
  }
  render() {
    const { classes} = this.props;
    return (
      <div className="registerView">
        <div className="text">Choose password</div>
        <TextField
          id="password"
          type="password"
          placeholder="Password"
          margin="normal"
          variant="outlined"
          classes={{
            root: classes.cssLabel,
          }}
          InputProps={{
            classes: {
              root: classes.cssOutlinedInput,
              notchedOutline: classes.notchedOutline,
              focused: classes.inputFocused,
              input: classes.inputWrapper,
            },
            startAdornment: (<InputAdornment position="start"><LockIcon className={classes.icon} /></InputAdornment>),
          }}
          error={this.state.errorPassword}
          value={this.state.password}
          onChange={this.handleChange('password')}
          disabled={this.state.isLoading}
        />
        <TextField
          id="confirmPassword"
          type="password"
          placeholder="Confirm password"
          margin="normal"
          variant="outlined"
          classes={{
            root: classes.cssLabel,
          }}
          InputProps={{
            classes: {
              root: classes.cssOutlinedInput,
              notchedOutline: classes.notchedOutline,
              focused: classes.inputFocused,
              input: classes.inputWrapper,
            },
            startAdornment: (<InputAdornment position="start"><LockIcon className={classes.icon} /></InputAdornment>),
          }}
          onKeyDown={this._handleKeyDown}
          error={this.state.errorCPassword}
          value={this.state.confirmPassword}
          onChange={this.handleChange('confirmPassword')}
          disabled={this.state.isLoading}
        />
        {!this.state.loading ? <div className="stepButton"><Button onClick={this.onNextClick} variant="contained" color="primary">Create Account</Button></div> : <div className="showbox">
            <div className="loader" style={{marginTop: "27px"}}>
              <svg className="circular" viewBox="25 25 50 50">
                <circle className="path" cx="50" cy="50" r="20" fill="none" strokeWidth="2" strokeMiterlimit="10"/>
              </svg>
            </div>
          </div>
        }
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          classes={{root: classes.error}}
          open={this.state.errorMessage.length > 0}
          autoHideDuration={3000}
          onClose={this.handleClose}
          ContentProps={{'aria-describedby': 'message-id',}}
          message={<span id="message-id">{this.state.errorMessage}</span>}
        />
      </div>
    );
  }
}
Step3.defaultProps = {
  onNext: ()=>{},
};
Step3.propTypes = {
  classes: PropTypes.object,
  onNext: PropTypes.func,
};
const mapStateToProps = state => ({
  ...state
})
const mapDispatchToProps = {}

Step3 = connect(mapStateToProps, mapDispatchToProps)(Step3);
export default withStyles(styles)(Step3);